import { render, staticRenderFns } from "./Moneda.vue?vue&type=template&id=a85d4b7e"
import script from "./Moneda.vue?vue&type=script&lang=js"
export * from "./Moneda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports